// AdminNotificationBell.jsx
import { useState, useEffect } from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useSelector, useDispatch } from "react-redux";
import {
    subscribeAdminNotifications,
    // resetAndLoadFirstPage,  // ⛔ больше не дергаем отсюда
} from "../../actions/adminNotificationActions";
import AdminNotificationPanel from "./AdminNotificationsPanel";
import AdminNotificationToast from "./AdminNotificationToast";
import TestButton from "./TestButton";

const AdminNotificationBell = () => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [toastList, setToastList] = useState([]);
    const { notifications = [] } = useSelector((state) => state.notification);

    useEffect(() => {
        dispatch(subscribeAdminNotifications());
    }, [dispatch]);

    useEffect(() => {
        const onToast = (e) => setToastList((prev) => [...prev, e.detail]);
        window.addEventListener("admin-toast", onToast);
        return () => window.removeEventListener("admin-toast", onToast);
    }, []);

    const unreadCount = notifications.filter((n) => !n.isRead).length;

    return (
        <>
            {toastList.map((t, i) => (
                <AdminNotificationToast
                    key={t._id || i}
                    data={t}
                    onClose={() => {
                        setToastList((prev) => prev.filter((_, idx) => idx !== i));
                    }}
                />
            ))}
        </>
    );
};

export default AdminNotificationBell;
